import FlintLabel from "./FlintLabel";
import {Label} from "@progress/kendo-react-labels";

export default function FlintLabelBox(props:FLintLabelBoxProps) {
    const className = props.className ? `${props.className} flint-box-container` : "flint-box-container";
    return (
        <div className={className}>
            <div>
                {props.titleIsHtml &&
                <label className="title-label" dangerouslySetInnerHTML={{__html : props.title}}></label>}
                {!props.titleIsHtml &&
                <FlintLabel className={"title-label"}>{props.title}</FlintLabel>}
            </div>
            {props.text != null && <FlintLabel>{props.text}</FlintLabel>}
            {props.html != null && <div dangerouslySetInnerHTML={{__html: props.html}}></div>}
        </div>
    )
}

export interface FLintLabelBoxProps {
    title: string;
    titleIsHtml?:boolean;
    text?: string | number | undefined | null;
    html?: string | undefined | null;
    className?: string | null;
}